export default __webpack_public_path__ + "static/media/turnkeyBanner.796fd9ee.jpg";